import { UdfGroup } from '@feature/_app_modules/additional-information/models/UdfGroups';
import { EntityKey } from '@feature/pma-document-centre/pma-document-centre-types';
import { Details } from '@details/Interfaces/details';

export class SectionControlItem {
  Name: string;
  Description: string;
  Allowed: boolean;
  Default: boolean;
}

export interface SaveAdditionalInformationUserSelectedSectionsRequest {
  DashboardWidgetId: number;
  SelectedSections: UdfGroup[];
}

export interface AvailableGroupsRequest {
  Key: EntityKey;
  WidgetConfigurationId: number;
}

export interface AdditionalInformationRequest {
  Key: EntityKey;
  DashboardWidgetId: number;
}
export interface AdditionalInformationByKeyRequest {
  Key: EntityKey
}
export interface AdditionalInformationDetailsResponse {
  AdditionalInformation: Details;
}
